import {v4 as uuidv4} from 'uuid';

// Keep in sync with benchling/versioning/patch_api.py
export const ACTION_CHECKOUT_FILE = 'CHECKOUT_FILE';
export const ACTION_ARCHIVE_ROWS = 'ACTION_ARCHIVE_ROWS';
export const ACTION_CREATE_APP_CANVAS = 'ACTION_CREATE_APP_CANVAS';
export const ACTION_CREATE_PLATES = 'ACTION_CREATE_PLATES';
export const ACTION_CREATE_ROW_PLATES = 'CREATE_ROW_PLATES';
export const ACTION_CREATE_BOXES = 'ACTION_CREATE_BOXES';
export const ACTION_CREATE_NEW_DRAFT = 'CREATE_NEW_DRAFT';
export const ACTION_CREATE_ROW_BOXES = 'CREATE_ROW_BOXES';
export const ACTION_REGISTER = 'REGISTER';
export const ACTION_REGISTER_ROWS = 'REGISTER_ROWS';
export const ACTION_TRANSFER = 'TRANSFER';
export const ACTION_TRANSFER_ROWS = 'TRANSFER_ROWS';
export const ACTION_SUBMIT_MIXTURE_PREP = 'SUBMIT_MIXTURE_PREP';
export const ACTION_SYNC_FILE = 'SYNC_FILE';
export const ACTION_UPDATE_COMPUTED_TAGS = 'UPDATE_COMPUTED_TAGS';
export const ACTION_REFRESH = 'REFRESH';
export const ACTION_RESET_VERSION = 'RESET_VERSION';
export const ACTION_CREATE_RUN = 'CREATE_RUN';
export const ACTION_SUBMIT_RESULTS = 'SUBMIT_RESULTS';
export const ACTION_SUBMIT_RESULTS_ROWS = 'SUBMIT_RESULTS_ROWS';
export const ACTION_SUBMIT_PROCESS_OUTPUTS = 'SUBMIT_PROCESS_OUTPUTS';
export const ACTION_SUBMIT_PROCESS_OUTPUTS_ROWS = 'SUBMIT_PROCESS_OUTPUTS_ROWS';
export const ACTION_SUBMIT_PROCESS_TASKS = 'SUBMIT_PROCESS_TASKS';
export const ACTION_SUBMIT_PROCESS_TASKS_ROWS = 'SUBMIT_PROCESS_TASKS_ROWS';
export const ACTION_PROCESS_TASK_FINDER = 'ACTION_PROCESS_TASK_FINDER';
export const ACTION_UNDO_PROCESS_TASK_EXECUTION = 'ACTION_UNDO_PROCESS_TASK_EXECUTION';
export const ACTION_INVENTORY_SUBMIT = 'INVENTORY_SUBMIT';
export const ACTION_SUBMIT_INVENTORY_ROW = 'INVENTORY_ROW_SUBMIT';
export const ACTION_SUBMIT_TEXT_BOX = 'SUBMIT_TEXT_BOX';
export const ACTION_RENAME_TEXT_BOX = 'RENAME_TEXT_BOX';
export const ACTION_SUBMIT_PARAMETER = 'SUBMIT_PARAMETER';
// A UUID to be sent in API requests for versioned objects (e.g. entries)
export const clientId = uuidv4();
